import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


function FournisseurGestionAutocomplete({ onChange, required, variant, size, color, autoFocus, error, helperText, withConditionsSAVGenerales, clientId, codeDepot, autoriseSAV, disabled }) {

    const [fournisseurs, setFournisseurs] = useState([]);

    const [selected, setSelected] = React.useState(null);

    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);

    const [loading, setLoading] = useState(false);
    

    // Fetch des fournisseurs
    useEffect(() => {
        const fetchData = async () => {

            if (query.length >= 2) {

                let cache = null;

                let len = query.length;
                do {
                    cache = results.find(x => x.key === query.substring(0, len)); // eslint-disable-line no-loop-func
                    len--;
                }
                while (!cache && (len >= 2));


                if (cache) {
                    setFournisseurs(cache.data);
                }
                else {
                    setLoading(true);

                    axios.get(`api/fournisseurs/suggestion?query=${query}&withConditionsSAVGenerales=${withConditionsSAVGenerales}&clientId=${clientId}&codeDepot=${codeDepot}&autoriseSAV=${autoriseSAV}`)
                        .then((response) => {

                            setResults([...results, { key: query, data: response.data }]);
                            setFournisseurs(response.data);

                        })
                        .catch((error) => {
                            console.log(error);
                            //setError(true);
                        })
                        .then(() => {
                            // always executed
                            setLoading(false);
                        });
                }
            }
        };

        fetchData();
    }, [query, withConditionsSAVGenerales]);


    return (
        <React.Fragment>

            <Autocomplete

                options={fournisseurs}
                getOptionLabel={(option) => option.code + ' - ' + option.nom}

                loading={loading}
                disabled={disabled}

                value={selected}
                onChange={(event, newValue) => {
                    setSelected(newValue);
                    onChange(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                    setQuery(newInputValue);
                }}

                isOptionEqualToValue={(option, value) => {
                    return (option.id === value.id);
                }}

                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Fournisseur"
                        placeholder="Saisir un code ou un nom de fournisseur"
                        required={required}
                        variant={variant}
                        size={size}
                        color={color}
                        fullWidth
                        InputLabelProps={{
                            shrink: true
                        }}
                        autoFocus={autoFocus}
                        error={error}
                        helperText={helperText}
                    />
                )}
            />


        </React.Fragment>
    );




}

FournisseurGestionAutocomplete.propTypes = {
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    fournisseurId: PropTypes.number,
    clientId: PropTypes.number,
    codeDepot: PropTypes.string,

    variant: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    autoFocus: PropTypes.bool,

    error: PropTypes.bool,
    helperText: PropTypes.string,

    withConditionsSAVGenerales: PropTypes.bool,
    autoriseSAV: PropTypes.bool,
    disabled: PropTypes.bool,
};

FournisseurGestionAutocomplete.defaultProps = {
    required: false,
    fournisseurId: 0,
    clientId: null,
    codeDepot: null,

    variant: "outlined",
    size: "medium",
    color: "primary",
    autoFocus: false,

    error: false,
    helperText: "",

    withConditionsSAVGenerales: false,
    autoriseSAV: false,
    disabled: false
}


export default FournisseurGestionAutocomplete;